var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestaurant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.679 2.5 2.586 2.587a2.143 2.143 0 0 1 .628 1.515V7.1a.536.536 0 0 0 .157.379l.379.378M8.357 8.93 7.98 8.55a.536.536 0 0 0-.38-.157h-.497a2.143 2.143 0 0 1-1.515-.628L3 5.18m1.34-1.34 2.678 2.679m5.357 7.232 3.34 3.358a1.34 1.34 0 0 0 1.893-1.894l-2.822-2.803m2.36-9.384L4.812 15.363a1.248 1.248 0 0 0 1.765 1.765l3.013-3.065c.198-.2.308-.47.308-.751v-.185a1.071 1.071 0 0 1 .32-.763l.388-.36a1.073 1.073 0 0 1 .998-.248 1.624 1.624 0 0 0 1.559-.423l2.86-2.861c1.697-1.697 2.322-4.26 1.125-5.445z",
    stroke: "#667085",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurant);
export default __webpack_public_path__ + "static/media/restaurant.c3ec213639e33fe7b86d96c1da4e46a4.svg";
export { ForwardRef as ReactComponent };